/* Use this component to extend specific search components */
import { Component, Input, Output, EventEmitter, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';
import * as Models from '@shared/core/models';

import { Observable } from 'rxjs';

@Component({
    template: '<div>This component requires extending</div>'
})
export class SearchComponent implements OnInit {
    public preHead: string = 'GOOD MORNING';

    @Input() public scrollTopOnSearch: boolean = false;
    @Input() public inputTypeDelay!: number;
    @Input() public open: boolean = true;
    @Input() public enableClose!: boolean;
    @Input() public enableSubmit!: boolean;
    @Input() public enableClear!: boolean;
    @Input() public placeholder!: string;

    @Output() public onToggleOpen: EventEmitter<boolean> = new EventEmitter();
    @Output() public onTypeChange: EventEmitter<{ previous: string; current: string; }> = new EventEmitter();

    public searchInput$!: Observable<string>;
    public isDelivery$!: Observable<boolean>;
    public deliveryTypes$!: Observable<Models.CollectionTypeItem[]>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        if (!this.placeholder) {
            this.placeholder = this.config.ui?.searchPlaceholderText || 'Search by suburb, city, zip';
        }

        this.isDelivery$ = this.controllers.collectionType.isDeliveryActive$();
        this.deliveryTypes$ = this.controllers.collectionType.collectionTypesLinks$();
    }

    public onSearchType(form: FormGroup): void {
        console.warn('Implement onSearch method');
    }

    public async onSearch(obj: {
        form: FormGroup;
        delivery: APICommon.IGooglePlaceDetails;
    }): Promise<boolean> {
        console.warn('Implement onSearch method');

        return false;
    }

    public onSearchReset(form: FormGroup): void {
        console.warn('Implement onSearchReset method');
    }

    public handleToggleOpen($event: { isOpen: boolean; form: FormGroup; }): void {
        this.onToggleOpen.emit($event.isOpen);
    }
}
